<template>
  <div class="">
    <!-- :title="route.routeName" -->
    <page-header v-if="route" title="View Route" breadcrumb="Dashboard >> Settings >> Routes >> Route" />

    <div class="custom-card" v-if="route">
      <create-route-form v-if="isIntrastate" :states="states" :route="route" edit />
    </div>

  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

import CreateRouteForm from '../NewRoute/partials/CreateRouteForm.vue';



export default {
  components: {
    CreateRouteForm,
    PageHeader

  },
  data() {
    return {
      routeId: null,
      states: [],
      route: null
      // updatingRoute: false,
    };
  },
  mounted() {
    this.routeId = localStorage.getItem("routeId");
    if (this.routeId) {
      this.getRouteDetails();
    } else {
      this.$router.push({ name: "Route" });
    }
    this.getAllStatesAndCities();
  },
  methods: {
    async getRouteDetails() {
      try {
        let response = await this.$_getSingleRoute(this.routeId);
        console.log(JSON.stringify(response.data.data.shippingService, null, 2));
        this.route = response.data.data.shippingService;
      } catch (error) {
        this.handleError(error);
      }
    },

    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        this.states = response.data.findState;
      } catch (error) {
        this.handleError(error);
      }
    }
  },
  computed: {
    isInterstate() {
      if (this.route) return this.route.isInterstate;
      else return false;
    },
    isIntrastate() {
      if (this.route) return this.route.isIntrastate;
      else return false;
    },
  },
};
</script>

<style>
</style>
